<template>
  <v-container fluid>
    <section class="library-search-main">
      <div class="library-title-block mb-2">
        <h3 class="tit">유형별 모아보기</h3>
      </div>
      <v-btn-toggle v-model="tab"
                    group dense color="primary"
                    class="toggle-category-group"
      >
        <v-btn v-for="item in tabs" :key="item.cd"
               active-class="active"
               style="min-width: 50px"
               depressed small outlined class="rounded-pill" :ripple="false"
        >{{ item.cdNm }}
        </v-btn>
      </v-btn-toggle>
      <br/>
      <br/>
      <div class="library-title-block mb-2">
        <h3 class="tit">인기 콘텐츠</h3>
      </div>
      <v-fade-transition>
        <LibraryItemList :items="items" :busy="isLoading" />
      </v-fade-transition>
    </section>
  </v-container>
</template>

<script>
import store from '@/store'
import LibraryItemList from './LibraryItemList.vue'

export default {
  name: 'LibrarySearchMain',
  components: {
    LibraryItemList
  },
  mixins: [],
  props: {},
  data: () => ({
    isLoading: false,
    tab: null,
    tabs: [],
    items: []
  }),
  computed: {},
  watch: {
    tab: {
      immediate: true,
      handler () {
        this.viewList()
      }
    }
  },
  created () {
    this.getCodeList('LB002')
  },
  activated () {
    if (this.$route.params.reload === 'true') {
      this.tab = null
    }
  },
  methods: {
    async getCodeList(cdGrp) {
      this.isLoading = true
      await store.dispatch('getCodeList', this.$_payload({'cdGrp': cdGrp}))
        .then(res => {
          if (res.success) {
            this.tabs = res.data;
          } else {
            this.tabs = []
          }
        })
        .catch(() => {
          this.tabs = null
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async viewList() {
      let type = this.tab === null || this.tab === undefined ? '' : this.tabs[this.tab]['cd']
      let params = [
        {type: type},
        {searchOrderBy: 'inqCnt'}
      ]
      this.isLoading = true
      await store.dispatch('getLibraryList', this.$_payload('so', params))
        .then(res => {
          if (res.success) {
            this.items = res.data.contents.slice(0, 10); // #11665 인기컨텐츠 노출 갯수 10개
          } else {
            this.items = []
          }
        })
        .catch(() => {
          this.items = []
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
